import { useCallback, useEffect, useRef } from 'react';

import { useRefreshToken } from '@/features/auth/api';
import { isEmpty } from 'lodash';

import {
    REFRESH_TOKEN_INTERVAL_CHECK_MS,
    REFRESH_TOKEN_THRESHOLD_MINUTES,
} from '@/lib/constants';

import { useActivity } from '@/hooks/useActivity';
import { useAuthData } from '@/hooks/useApiKey';

export function useTokenRefresh() {
    const { accessTokenExpiresAt, refreshToken } = useAuthData();
    const [isUserActive] = useActivity();
    const refreshTokenMutation = useRefreshToken();

    const handleRefreshToken = useCallback(() => {
        refreshTokenMutation.mutate(refreshToken);
    }, [refreshTokenMutation, refreshToken]);

    const handleRefreshTokenRef = useRef(handleRefreshToken);

    useEffect(() => {
        handleRefreshTokenRef.current = handleRefreshToken;
    }, [handleRefreshToken]);

    useEffect(() => {
        const interval = setInterval(() => {
            const isWithinRefreshThreshold =
                Date.now() >=
                new Date(accessTokenExpiresAt).getTime() -
                    REFRESH_TOKEN_THRESHOLD_MINUTES * 60 * 1000;
            if (
                isUserActive() &&
                !isEmpty(accessTokenExpiresAt) &&
                isWithinRefreshThreshold
            ) {
                handleRefreshTokenRef.current();
            }
        }, REFRESH_TOKEN_INTERVAL_CHECK_MS);

        return () => {
            clearInterval(interval);
        };
    }, [accessTokenExpiresAt, isUserActive]);
}
